// DS: I109
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
const ArtStageArrowR = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "27",
        height: "48",
        viewBox: "0 0 27 48",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M24 27L3 48l-3-3 21-21L0 3l3-3 24 24-3 3z",
        fillRule: "evenodd"
    })));
ArtStageArrowR.displayName = 'ArtStageArrowR';
export default ArtStageArrowR;
